module.exports = {
  webSocket: process.env.WebSocket
};
